export { registerHtmlAttributePlugin } from '../plugins/builtin-plugin/html-attribute-plugin';
export { registerReactAttributePlugin } from '../plugins/builtin-plugin/react-attribute-plugin';
